<template>
  <li class="skill-dive-lab-row" @click="goToContent">
    <div
      v-if="content.difficulty"
      class="skill-dive-lab-row__difficulty-learning-area-icon"
    >
      <DifficultyLearningAreaIcon
        :difficulty="content.difficulty"
        :learningArea="learningAreaName"
      />
    </div>
    <div class="skill-dive-lab-row__info-container__wrapper">
      <div class="skill-dive-lab-row__info-container">
        <div
          v-if="content.published_date && showAddedDaysAgo"
          class="skill-dive-lab-row__info-container__added-date-wrapper"
        >
          <AddedDaysAgo :label="addedTimeAgoLabel" />
        </div>
        <ContentRowMainInfo
          :content="content"
          :locked="lockedContent"
          @toggle-expand="toggleExpand"
        />
        <transition
          name="skill-dive-lab-row__info-container__details-container--expand"
        >
          <div
            v-if="isExpanded"
            class="skill-dive-lab-row__info-container__details-container"
          >
            <div class="skill-dive-lab-row__separator"></div>
            <ContentRowDetails
              :content="content"
              :locked="lockedContent"
              @tag-selected="handleTagSelection"
            />
          </div>
        </transition>
      </div>
    </div>
  </li>
</template>
<script>
import ContentRowMainInfo from './ContentRowMainInfo.vue'
import ContentRowDetails from './ContentRowDetails.vue'
import { getLearningAreaColor, getLearningAreaName } from '@/helpers'
import DifficultyLearningAreaIcon from '@/components/properties/DifficultyLearningAreaIcon.vue'
import AddedDaysAgo from '@/components/search/content-rows/AddedDaysAgo.vue'
import { collectionCommons } from '@/helpers/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'SkillDiveLabRow',
  components: {
    ContentRowMainInfo,
    ContentRowDetails,
    AddedDaysAgo,
    DifficultyLearningAreaIcon,
  },
  mixins: [collectionCommons],
  props: {
    content: {
      type: Object,
      required: true,
    },
    allExpanded: {
      type: Boolean,
      default: false,
    },
    learningAreasAllowed: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      isExpanded: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
    }),
    learningAreaName() {
      return getLearningAreaName(this.content) // Design limitation (only one Hexagon)
    },
    learningAreaColor() {
      return getLearningAreaColor(this.content)
    },
    lockedContent() {
      const las = this.content.learning_areas.map(la => la.name)
      return !this.learningAreasAllowed.some(la => las.includes(la.name))
    },
  },
  watch: {
    allExpanded(value) {
      this.isExpanded = value
    },
  },
  methods: {
    goToContent() {
      if (this.lockedContent) {
        if (this.isSkillDiveB2CUser) {
          this.$router.push({
            name: 'user-dashboard',
            params: {
              mode: 'subscriptions',
            },
          })
        } else {
          window.location.href = `https://${process.env.VUE_APP_CHECKOUT_URL}`
        }
      } else {
        this.$router.push({
          name: 'lab-modal',
          params: { labId: this.content.uuid || this.content.objectID },
        })
      }
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
      this.$emit('row-collapsed')
    },
    handleTagSelection(value) {
      this.$emit('tag-selected', value)
    },
  },
}
</script>
<style scoped lang="scss">
.skill-dive-lab-row {
  display: flex;
  position: relative;
  &__difficulty-learning-area-icon {
    position: absolute;
    display: flex;
    height: 100%;
    > div {
      height: 85px;

      @include mobile {
        height: 99px;
      }
    }
  }

  &__info-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    color: var(--white);

    background: var(--glass-mid-gray);

    &:hover {
      background: var(--glass-light-gray);
    }
    &:active {
      background: var(--glass-dark);
    }
    cursor: pointer;

    border-radius: 10px;
    padding: 10px 10px 10px 40px;
    @include mobile {
      height: auto;
      padding: 17px 17px 17px 40px;
    }

    &--expand {
      height: auto;
    }

    &__added-date-wrapper {
      position: absolute;
      top: 0;
      right: 0;
    }
    &__details-container {
      max-height: 1000px;
      opacity: 1;
      padding-right: 30px;

      &--expand {
        &-enter-active,
        &-leave-active {
          transition: all 0.2s ease-in-out;
        }
        &-enter,
        &-leave-to {
          max-height: 0px;
          opacity: 0;
        }
      }
    }
    &__wrapper {
      width: 100%;
      border-radius: 10px;
      background: linear-gradient(
          0deg,
          rgba(0, 0, 0, 0.2) 0%,
          rgba(0, 0, 0, 0.2) 100%
        ),
        #222;
      box-shadow: 0px 30px 48px 0px rgba(0, 0, 0, 0.25);

      margin-left: 60px;
    }
  }
  &__separator {
    background: var(--glass-light-gray);
    height: 1px;

    margin: 10px 0;
  }
}
</style>
